<div class="dialog-container">
  <h2 mat-dialog-title>{{ 'dialog_reject_custom_industry_title' | translate }}</h2>
  <p *ngIf="data.industryDisplayName">
    {{ 'dialog_reject_custom_industry_plant' | translate }} <strong>{{ data.industryDisplayName }}</strong>
  </p>

  <mat-dialog-content [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'dialog_reject_custom_industry_reason' | translate }}</mat-label>
      <textarea matInput formControlName="comment" rows="3" required></textarea>
      <mat-error *ngIf="form.get('comment')?.hasError('required')">{{ 'dialog_reject_custom_industry_reason_required' | translate }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{ 'common_btn_cancel' | translate }}</button>
    <button mat-flat-button color="warn" [disabled]="!form.valid" (click)="onSave()">{{ 'industrie_validation_refuse_btn' | translate }}</button>
  </mat-dialog-actions>
</div>
